import './bread-crumbs.scss';

import { Link } from 'react-router';

interface IProps {
  currentPage: string;
  previousPages: Array<
    | {
        type: 'link';
        name: string;
        href: string;
        onClick?: () => void;
      }
    | {
        type: 'button';
        name: string;
        href?: never;
        onClick: () => void;
      }
  >;
}

const BreadCrumbs: React.FC<IProps> = ({ currentPage, previousPages }) => {
  return (
    <div className="client-bread-crumbs">
      {previousPages.map((page) =>
        page.type === 'button' ? (
          <button
            type="button"
            className="client-bread-crumbs__prev-page"
            onClick={page.onClick}
            key={page.name}
          >
            {page.name}
          </button>
        ) : (
          <Link
            className="client-bread-crumbs__prev-page"
            onClick={page.onClick}
            key={page.name}
            to={page.href}
          >
            {page.name}
          </Link>
        )
      )}
      <span className="client-bread-crumbs__current-page">{currentPage}</span>
    </div>
  );
};

export default BreadCrumbs;
